import gql from 'graphql-tag';

export default gql`
    query {
         getAllNetworks {
            id,
            alias
        }
    }
`;